import { useState } from "react";
import { toast } from "react-toastify";
import AuthWrapper1 from "./AuthWrapper1";
import { useSetRecoilState } from "recoil";
import { useTheme } from "@mui/material/styles";
import AuthCardWrapper from "./AuthCardWrapper";
import AuthLogin from "../auth-forms/AuthLogin";
import { BASE_PATH } from "../../../environment";
import ForgotPassword from "../auth-forms/ForgotPassword";
import Logo from "../../../layout/MainLayout/LogoSection/Logo";
import { Employee, EmployeeApi } from "../../../api/clinic-management";
import AuthFooter from "../../../styles/ui-component/cards/AuthFooter";
import { loginInfo, branchRoles, configState, loggedEmployee } from "../../../recoil/atoms";
import {Box, Button, Divider, Grid, IconButton, Modal, Paper, Stack, Typography, useMediaQuery} from "@mui/material";
import { Configuration, LoginRequest, Role, RoleApi, UserApi, ValidateCredsResponseBranches } from "../../../api/auth";

const Login = () => {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));
  
  const [credentials, setCredentials] = useState<any>();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [showBranches, setShowBranches] = useState<boolean>(false);

  const setRoles = useSetRecoilState<Role[]>(branchRoles);
  const setAccessTokenGlobal = useSetRecoilState(configState);
  const setEmployee = useSetRecoilState<Employee>(loggedEmployee);
  const setLoggedInBranch = useSetRecoilState<ValidateCredsResponseBranches>(loginInfo);

  const configLogin: Configuration = {
    basePath: BASE_PATH,
    apiKey: credentials?.LoginToken,
  };

  const loginBranch = (values: LoginRequest) => {
    const user = new UserApi(configLogin);
    user
      .login(values)
      .then((res) => {
        localStorage.setItem("AccessToken", res.data.AccessToken!);
        localStorage.setItem("RefreshToken", res.data.RefreshToken!);
        setAccessTokenGlobal({ ...configState, apiKey: res.data.AccessToken! });
        setLoggedInBranch(res?.data);
        localStorage.setItem("LoginInfo", JSON.stringify(res?.data));
        getRoles(res?.data?.AccessToken!);
        getEmployee(res?.data?.AccessToken!, res.data.EmployeeID!);
        toast.success(res?.data?.Message!);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const submitLogin = (values: LoginRequest) => {
    loginBranch(values);
  };

  const getRoles = (apiKey: string) => {
    const role = new RoleApi({ basePath: BASE_PATH, apiKey: apiKey });
    role
      .getAllRoles()
      .then((res) => {
        setRoles(res.data);
        localStorage.setItem("BranchRoles", JSON.stringify(res.data));
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const getEmployee = (apiKey: string, employeeID: string) => {
    const employee = new EmployeeApi({ basePath: BASE_PATH, apiKey: apiKey });
    employee
      .getTenantEmployeeById(employeeID)
      .then((res) => {
        localStorage.setItem("LoggedEmployee", JSON.stringify(res.data));
        setEmployee(res.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: '300px',
    bgcolor: 'background.paper',
    border: '0',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
  };
  return (
    <>
      <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
              display="block"
              color="textSecondary"
              variant="caption"
              fontSize="16px"
              align="center"
          >
            Request Password Reset
          </Typography>
          <ForgotPassword setOpenModal={setOpenModal} />
        </Box>
      </Modal>
      <AuthWrapper1>
        <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: "100vh" }}>
          <Grid item xs={12}>
            <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: "calc(100vh - 68px)" }}>
              <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                <AuthCardWrapper>
                  <Grid container spacing={2} alignItems="center" justifyContent="center">
                    <Grid item sx={{ mb: 3 }}>
                      <Logo />
                    </Grid>
                    {!showBranches ? (
                      <>
                        <Grid item xs={12}>
                          <Grid
                            container
                            direction={matchDownSM ? "column-reverse" : "row"}
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Grid item>
                              <Stack alignItems="center" justifyContent="center" spacing={1}>
                                <Typography
                                  variant="caption"
                                  fontSize="16px"
                                  textAlign={matchDownSM ? "center" : "inherit"}
                                >
                                  Enter your credentials to continue
                                </Typography>
                              </Stack>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <AuthLogin setShowBranches={setShowBranches} setCredentials={setCredentials} />
                        </Grid>
                        <Grid item xs={12}>
                          <Divider />
                        </Grid>
                        <Grid item container direction="column" alignItems="center" xs={12}>
                          <Button
                              onClick={handleOpenModal}
                          >
                            Forgot Password?
                          </Button>
                        </Grid>
                      </>
                    ) : (
                      <>
                        <Grid item xs={12}>
                          <Grid container direction={"column"} alignItems="center" justifyContent="center">
                            <Grid item>
                              <Typography
                                color="#90CAF9"
                                gutterBottom
                                variant={matchDownSM ? "h4" : "h3"}
                                pt={"2em"}
                                sx={{ fontWeight: "light" }}
                              >
                                Please, Choose a Branch:
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                            {credentials.Branches.map((branch: any) => (
                              <IconButton
                                sx={{
                                  "&:hover": {
                                    borderRadius: 0,
                                    padding: 0,
                                  },
                                  borderRadius: 0,
                                  padding: 0,
                                  margin: "1em",
                                }}
                              >
                                <Paper
                                  sx={{
                                    width: "10em",
                                    padding: "0.5em",
                                    color: "#5e35b1",
                                    "&:hover": {
                                      color: "#90CAF9",
                                    },
                                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
                                  }}
                                  onClick={() => {
                                    submitLogin({
                                      BranchID: branch.BranchID,
                                      TenantID: branch.TenantID,
                                    });
                                  }}
                                >
                                  {branch.Name}
                                </Paper>
                              </IconButton>
                            ))}
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </AuthCardWrapper>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
            <AuthFooter />
          </Grid>
        </Grid>
      </AuthWrapper1>
    </>
  );
};

export default Login;
